import component from '@gov.wa.lni/application.isolated-workers-complaint/source/components/lni-isolated-workers-complaint-form/lni-isolated-workers-complaint-form.component.vue';
import module from '@gov.wa.lni/application.isolated-workers-complaint/source/components/lni-isolated-workers-complaint-form/lni-isolated-workers-complaint-form.module';

export default {
    component,
    module,
};